import React, { useState, useEffect, useContext } from 'react'
import AuthContext from '../context/AuthContext'
import useAxios from '../utils/useAxios'

function AddInvoice({postInvoice}) {

    let [categories, setCategories] = useState([])
    let [moneyTypes, setMoneyTypes] = useState([])
    let {user} = useContext(AuthContext)

    let api = useAxios()

    let getCategories = async () => {
        let response = await api.get('/api/company-categories/' + user.company)
        if (response.status === 200) {
            setCategories(response.data)
        }
    }

    let getMoneyTypes = async () => {
        let response = await api.get('/api/money-types/')
        if (response.status === 200) {
            setMoneyTypes(response.data)
        }
    }

    useEffect(() => {
        getCategories()
        getMoneyTypes()
    }, [])

    // let postInvoice = async (e) => {
    //     e.preventDefault()
    //     let current_invoice_files = []
    //     for (let i = 0; i < e.target.invoice_files.files.length; i++) {
    //         current_invoice_files.push(e.target.invoice_files.files[i])
    //     }
    //     let response = await api.post('/api/invoice/', {
    //         'name': e.target.name.value,
    //         'description': e.target.description.value,
    //         'invoice_date': e.target.invoice_date.value,
    //         // 'invoice_image': e.target.invoice_image.files[0],
    //         'invoice_files': current_invoice_files,
    //         'total_amount_of_invoice': e.target.total_amount_of_invoice.value,
    //         'amount_money_type': e.target.amount_money_type.value,
    //         'employee': user.user_id,
    //         'category': e.target.category.value,
    //     }, {
    //         headers: {
    //             "Content-Type": "multipart/form-data",
    //         },
    //     })

    //     if (response.status === 201) {
    //         alert("Invoice Created Successfully")
    //     } else {
    //         alert("There was something error please try again")
    //     }
    // }


  return (

    <div>
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">New Invoice</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <form onSubmit={postInvoice}>
                <div className="mb-3">
                    <label htmlFor='name' className="col-form-label">Invoice name</label>
                    <input type="text" className="form-control" id="name" name='name'/>
                </div>
                <div className="mb-3">
                    <label htmlFor='category' className="col-form-label">Invoice category</label>
                    <select className="form-select" aria-label="Default select example" name='category'>
                        {categories.map(category => (
                            <option key={category.id} value={category.id}>{category.name}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor='description' className="col-form-label">Description:</label>
                    <input type="text" className="form-control" id="description" name='description' />
                </div>
                <div className="mb-3">
                    <label htmlFor='invoice_date' className="col-form-label">Invoice Date:</label>
                    <input type="date" className="form-control" id="invoice_date" name='invoice_date' />
                </div>
                <div className="row mb-3">
                    <div className='col-auto'>
                    <label htmlFor='total_amount_of_invoice' className="col-form-label">Invoice Amount:</label>
                    <input type="number" className="form-control" id="total_amount_of_invoice" name='total_amount_of_invoice' />
                    </div>
                    <div className='col-auto'>
                    <label htmlFor='amount_money_type' className="col-form-label">Currency</label>
                    <select className="form-select" aria-label="Default select example" name='amount_money_type'>
                        {moneyTypes.map(moneyType => {
                            if (user.company === 1 && moneyType.name === 'ليرة سوري') {
                                return (<option key={moneyType.id} value={moneyType.id} selected>{moneyType.name}</option>)
                            } else {
                                return (
                                    <option key={moneyType.id} value={moneyType.id}>{moneyType.name}</option>
                                )
                            }
                        })}
                    </select>
                    </div>
                </div>
                {/* <div className="mb-3">
                    <label htmlFor='invoice_image' className="form-label">Default file input example</label>
                    <input className="form-control" type="file" accept='image/png, image/jpeg' id="invoice_image" name='invoice_image' />
                </div> */}
                <div className="mb-3">
                    <label htmlFor='invoice_files' className="form-label">Invoice Files:</label>
                    <input className="form-control" type="file" accept='application/pdf, image/png, image/jpeg' id="invoice_files" name='invoice_files' multiple />
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <input type="submit" className="btn btn-success" value="Add" data-bs-dismiss="modal" />
                </div>
                </form>
            </div>

            </div>
        </div>
        </div>
    </div>
  )
}

export default AddInvoice